import React from 'react';
import PropTypes from 'prop-types';

import {
  MaterialIcon,
} from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { status } from '../../utils/constants';
import messages from './messages';
import {
  StatusInfoWrapper,
  StatusIcon,
  StatusMessage,
} from './styles';

const statusInfo = {
  [status.INPROGRESS]: { icon: 'warning_triangle', message: messages.warning },
  [status.COMPLETED]: { icon: 'check_circle_rounded', message: messages.uploadCompleted },
  [status.FAILED]: { icon: 'error', message: messages.uploadFailed },
};

const ExportStatusInfo = ({ exportStatus }) => exportStatus ? (
  <StatusInfoWrapper>
    <StatusIcon exportStatus={exportStatus}>
      <MaterialIcon id={statusInfo[exportStatus].icon} />
    </StatusIcon>
    <StatusMessage>{intl.formatMessage(statusInfo[exportStatus].message)}</StatusMessage>
  </StatusInfoWrapper>
) : null;

ExportStatusInfo.propTypes = {
  publicationStatus: PropTypes.string,
};

export default ExportStatusInfo;
